import DeleteAssetModal from './DeleteAssetModal.container';

export default DeleteAssetModal;
